export default __webpack_public_path__ + "static/media/50.1fd5eb38.png";